module.exports = __webpack_public_path__ + "img/icon.2a6945a6.svg";